import { render, staticRenderFns } from "./ReceiptPreview.vue?vue&type=template&id=04e4d39b&scoped=true&lang=pug&"
import script from "./ReceiptPreview.vue?vue&type=script&lang=js&"
export * from "./ReceiptPreview.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptPreview.vue?vue&type=style&index=0&id=04e4d39b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e4d39b",
  null
  
)

/* custom blocks */
import block0 from "./ReceiptPreview.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardTitle,VCol,VIcon,VLayout,VProgressCircular,VRow})
